import queryString from 'querystring';

import parse from 'html-react-parser';
import { FC } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { dataProductFull } from '../../../../store/location';
import { searchString } from '../../../../store/location/selectors';
import { togglePopup } from '../../../../store/ui';

const PriceTableText: FC<{ priceText: { href: string; text: string; title: string } }> = ({ priceText }) => {
    const dispatch = useDispatch();
    const { data: productData = null } = useSelector(dataProductFull);
    const search = useSelector(searchString);
    const parsedSearch = queryString.parse(search.replace('?', ''));
    if (parsedSearch.urn?.includes('?fbclid=')) {
        parsedSearch.urn = (parsedSearch.urn as string).split('?fbclid=')[0];
    }

    const handleClickOnLink = event => {
        if (
            !event.target.classList.contains('product-page__legal-notice-text') &&
            event.target.tagName === 'A' &&
            productData
        ) {
            const { number, title, requestofferbutton } = productData;
            const [format, address] = title.split('<br>');

            dispatch(
                togglePopup({
                    name: 'location_request',
                    status: true,
                    payload: [
                        {
                            format,
                            address,
                            id: number,
                            requestofferbutton: requestofferbutton,
                            urn: parsedSearch.urn as string,
                        },
                    ],
                })
            );
        }
    };

    return (
        <div className="product-page__legal-notice-wrapper">
            <h6>{priceText.title}</h6>
            <p
                className={'product-page__legal-notice-text'}
                onClick={(_event: any) => {
                    const clickedEl = _event.target as HTMLElement;
                    if (
                        clickedEl?.tagName === 'A' &&
                        clickedEl?.hasAttribute('href') &&
                        clickedEl?.getAttribute('href') === '#REQUEST#' &&
                        priceText.text.includes('href="#REQUEST#"')
                    ) {
                        _event.preventDefault();
                        handleClickOnLink(_event);
                    }
                }}
            >
                {parse(priceText.text) as never}
            </p>
            <br />
        </div>
    );
};

export default PriceTableText;
